<template>
  <div class="start">
    <h1>{{ title }}</h1>
    <img alt="Knusperjagd Logo" v-if="logoPath !== null" v-bind:src="logoPath">
    <Button v-if="button !== null" :text="button" type="explain" @open="explain" />
    <Explanation v-if="explanation" @gamestate="update" />
  </div>
</template>

<script>
const Button = () => import('./Buttons.vue')
const Explanation = () => import('./Explanation.vue')
// import Button from './Buttons.vue'
// import Explanation from './Explanation.vue'
export default {
  name: 'TitleScreen',
  components: {
    Button,
    Explanation
  },
  props: {
    title: String
  },
  data: function(){
    return {
      explanation: false,
      button: window.config.text.intro.button_start,
      logoPath: window.config.images.logo,
    }
  },
  methods: {
    update(){
      this.$emit('gamestate', 'running')
    },
    explain(){
      this.explanation = true;
    }
  }
}
</script>
